import { Navigate } from "react-router-dom";
import * as page from "pages";
import * as path from "constants/routerPath";
import { APP_IDS } from "constants/apps";
import ErrorBoundary from "components/errorBoundary/ErrorBoundary";
import FeatureErrorBoundary from "components/errorBoundary/FeatureErrorBoundary";

export const protectedRouteData = [
  { id: "1", path: path.ROUTE_HOME, component: <page.Home />, title: "Home" },
  {
    id: "4",
    path: path.ROUTE_CONTACTS,
    component: <page.Contacts />,
    title: "Contacts",
  },
  {
    id: "5",
    path: path.ROUTE_USERS,
    component: <page.Users />,
    title: "Users",
  },
  {
    id: "6",
    path: path.ROUTE_CHECKLISTS,
    appId: APP_IDS.CANDISPATCH,
    component: <page.Checklists />,
    title: "Checklists",
  },
  { id: "7", path: path.ROUTE_SHIFT_RPT, appId: APP_IDS.CANDISPATCH, component: <page.ShiftRpt /> },
  {
    id: "8",
    path: path.ROUTE_MENU_MGT,
    component: <page.Menus />,
    title: "Menus",
  },
  {
    id: "9",
    path: path.ROUTE_DENIED,
    component: <page.PermissionDenied />,
    title: "Permission Denied",
  },
  {
    id: "10",
    path: path.ROUTE_PROFILE,
    component: <page.Profile />,
    title: "Profile",
  },
  {
    id: "11",
    path: path.ROUTE_CANPARK_ADMIN,
    appId: APP_IDS.CANPARK,
    component: <page.CANparkAdmin />,
    title: "CANpark Admin",
  },
  {
    id: "12",
    path: path.ROUTE_CANSHARE,
    appId: APP_IDS.CANSHARE,
    component: <page.CanShare />,
    title: "CANshare",
  },
  {
    id: "13",
    path: path.ROUTE_INCIDENT_REPORT,
    appId: APP_IDS.CANDISPATCH,
    component: <page.GenerateIncidentReport />,
    title: "Incident Report",
  },
  {
    id: "14",
    path: path.ROUTE_CALENDAR,
    component: <page.CANcalendar />,
    title: "Calendar",
  },
  {
    id: "15",
    path: path.ROUTE_TIMESHEETS,
    appId: APP_IDS.CANTRACK,
    component: <page.Timesheets />,
    title: "Timesheets",
  },
  {
    id: "16",
    path: path.ROUTE_MAIL_LIST,
    appId: APP_IDS.CANMAIL,
    component: <page.ListManager />,
    title: "List Manager",
  },
  {
    id: "18",
    path: path.ROUTE_ANALYTICS_REPORT,
    component: <page.AnalyticsReport />,
    title: "Analytics Report",
  },
  {
    id: "19",
    path: path.ROUTE_CANPROSPECT,
    component: <page.CANprospect />,
    title: "CANprospect",
  },
  {
    id: "20",
    path: path.ROUTE_CANPROSPECT_EVENTS,
    component: <page.CANprospectEvents />,
    title: "CANprospectEvents",
  },
  {
    id: "22",
    path: path.ROUTE_SALES_ANALYTICS,
    component: <page.SalesAnalytics />,
    title: "Sales  Analytics 📊",
  },
  {
    id: "23",
    path: path.ROUTE_MEET,
    appId: APP_IDS.CANMEET,
    component: <page.MeetPage />,
    title: "CANmeet",
  },
  {
    id: "24",
    path: path.ROUTE_EMAIL_SENDER,
    appId: APP_IDS.CANMAIL,
    component: <page.EmailSenderPage />,
    title: "CANmail",
  },
  {
    id: "50",
    path: path.ROUTE_EMAIL_TEMPLATES,
    appId: APP_IDS.CANMAIL,
    component: <page.EmailTemplatesPage />,
    title: "Template Manager",
  },
  {
    id: "25",
    path: path.ROUTE_SURVEY_HOME,
    appId: APP_IDS.CANSURVEY,
    component: <FeatureErrorBoundary featureName="CANsurvey"><page.SurveyHomePage /></FeatureErrorBoundary>,
    title: "CANsurvey",
  },
  {
    id: "26",
    path: path.ROUTE_CREATE_SURVEY,
    appId: APP_IDS.CANSURVEY,
    component: <FeatureErrorBoundary featureName="CANsurvey"><page.CreateSurveyPage /></FeatureErrorBoundary>,
    title: "CANsurvey",
  },
  {
    id: "27",
    path: path.ROUTE_PREVIEW_SURVEY,
    appId: APP_IDS.CANSURVEY,
    component: <FeatureErrorBoundary featureName="CANsurvey"><page.PreviewSurveyPage /></FeatureErrorBoundary>,
    title: "CANsurvey",
  },
  {
		id: '29',
		path: path.ROUTE_SENSE,
		component: <Navigate to={path.ROUTE_SENSE_DASHBOARD} replace />,
		title: 'CANSense',
	},
  {
		id: '30',
		path: path.ROUTE_SENSE_DASHBOARD,
		component: <page.DashboardPage />,
		title: 'Dashboard',
	},
  {
		id: '30c',
		path: path.ROUTE_SENSE_MANAGEMENT,
		component: <page.ManagementPage />,
		title: 'Management',
	},
  // Legacy redirects
  {
		id: '30r1',
		path: path.ROUTE_SENSE_MONITORING,
		component: <Navigate to={path.ROUTE_SENSE_DASHBOARD} replace />,
		title: 'CANSense Monitoring Redirect',
	},
  {
		id: '30r2',
		path: path.ROUTE_SENSE_EXPORTERS,
		component: <Navigate to={path.ROUTE_SENSE_MANAGEMENT} replace />,
		title: 'CANSense Exporters Redirect',
	},
  {
		id: '30r3',
		path: path.ROUTE_SENSE_WEBSITES,
		component: <Navigate to={path.ROUTE_SENSE_MANAGEMENT} replace />,
		title: 'CANSense Websites Redirect',
	},
  {
		id: '31',
		path: path.ROUTE_CONSENT_LOG,
		appId: APP_IDS.CANMAIL,
		component: <page.ConsentLogPage />,
		title: 'Consent Log',
	},
  {
    id: "32",
    path: path.ROUTE_CANBLOG,
    component: <page.BlogListPage />,
    title: "CANblog",
  },
  {
    id: "33",
    path: path.ROUTE_CANBLOG_EDITOR,
    component: <page.BlogEditorPage />,
    title: "CANblog Editor",
  },
  {
    id: '34',
    path: path.ROUTE_EMAIL_HISTORY,
    appId: APP_IDS.CANMAIL,
    component: <page.EmailHistoryPage />,
    title: 'Email History',
  },
  {
    id: '35',
    path: path.ROUTE_CANAI,
    appId: APP_IDS.CANAI,
    component: <page.CANaiPage />,
    title: 'CANai',
  },
  {
    id: '36',
    path: path.ROUTE_TODO,
    component: <FeatureErrorBoundary featureName="Todo"><page.TodoPage /></FeatureErrorBoundary>,
    title: 'Todo',
  },
  {
    id: '37',
    path: path.ROUTE_CANVISION + '/*',
    appId: APP_IDS.CANVISION,
    component: <FeatureErrorBoundary featureName="CANvision"><page.CANvisionLayout /></FeatureErrorBoundary>,
    title: 'CANvision',
  },
  {
    id: '37b',
    path: '/canvms/*',
    component: <Navigate to={path.ROUTE_CANVISION} replace />,
    title: 'CANvision Redirect',
  },
  {
    id: '38',
    path: path.ROUTE_SCHEDULER,
    appId: APP_IDS.CANDISPATCH,
    component: <page.Scheduler />,
    title: 'Scheduler',
  },
  {
    id: '39',
    path: path.ROUTE_ACTIVITY_REPORT,
    appId: APP_IDS.CANDISPATCH,
    component: <ErrorBoundary><page.ActivityReportPage /></ErrorBoundary>,
    title: 'Activity Report',
  },
  {
    id: '40',
    path: path.ROUTE_GUARD_LOCATIONS,
    appId: APP_IDS.CANDISPATCH,
    component: <FeatureErrorBoundary featureName="Dashboard"><page.GuardLocationsPage /></FeatureErrorBoundary>,
    title: 'Guard Locations',
  },
  {
    id: '41',
    path: path.ROUTE_DISPATCH_NOTIFICATION_SETTINGS,
    appId: APP_IDS.CANDISPATCH,
    component: <page.DispatchNotificationSettingsPage />,
    title: 'Notification Settings',
  },
  {
    id: '42',
    path: path.ROUTE_CUSTOMERS,
    component: <page.Customers />,
    title: 'Customers',
  },
  {
    id: '43',
    path: path.ROUTE_ADDRESS_MANAGEMENT,
    component: <page.AddressManagement />,
    title: 'Addresses',
  },
  {
    id: '44',
    path: path.ROUTE_ANNOUNCEMENT_MANAGEMENT,
    component: <page.AnnouncementManagement />,
    title: 'Announcements',
  },
  {
    id: '45',
    path: path.ROUTE_DOWNLOADS,
    component: <page.Downloads />,
    title: 'Downloads',
  },
  {
    id: '46',
    path: path.ROUTE_FILEBUCKET_MANAGER,
    component: <page.FileBucketManager />,
    title: 'File Manager',
  },
  {
    id: '47',
    path: path.ROUTE_CASE_MANAGEMENT,
    component: <FeatureErrorBoundary featureName="Case Management"><page.CaseManagement /></FeatureErrorBoundary>,
    title: 'Case Management',
  },
  {
    id: '48',
    path: path.ROUTE_CANDOCS,
    component: <page.CANdocs />,
    title: 'Docs',
  },
  {
    id: '49',
    path: path.ROUTE_INSTANCE_SETTINGS,
    component: <page.InstanceSettings />,
    title: 'Instance Settings',
  },
  {
    id: '51',
    path: path.ROUTE_QUANTUM_HEALING_PARTICIPANTS,
    // The page checks for LBW_CANmail_Admin itself and sends anyone else to the
    // denied page — see useQuantumHealingAccess.
    component: (
      <FeatureErrorBoundary featureName="Quantum Healing">
        <page.QuantumHealingParticipants />
      </FeatureErrorBoundary>
    ),
    title: 'Quantum Healing Participants',
  },
  // CANtrack routes are handled via wildcard in RootRoute.jsx (/cantrack/*)
];
